import React from "react";
import { Link } from "react-router-dom";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY,
  STACK_GAP,
  INLINE_LINK,
} from "./sections";

const GoogleDocsComparisonSection = () => {
  return (
    <section
      id="google-docs-voice-typing-comparison"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>Google Docs Voice Typing Comparison</h2>

      <p className={`${STACK_GAP} ${BODY}`}>
        Google Docs Voice Typing is the most limited of the three simply
        because of where it lives: inside one app. It doesn&apos;t help if
        you&apos;re dictating a Slack message, an email in Gmail, or a prompt
        into an AI chat tool. Every time you switch context, you&apos;re back
        to typing or hunting for another dictation method.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        If most of your writing happens directly, our{" "}
        <Link to="/voice-typing-for-google-docs" className={INLINE_LINK}>
          Google Docs voice typing guide
        </Link>{" "}
        walks through getting AI-powered dictation set up specifically for that
        workflow, including how it compares to the native Tools &gt; Voice
        typing option.
      </p>
    </section>
  );
};

export default GoogleDocsComparisonSection;
